<div class="td-wb-form">
  <td-wb-modal-header iconId="tertiary--agreements"
    class="td-wb-modal__header">
    <td-wb-modal-header-title modalTitle="tdWb.platform.preferences.agreements.EXCHANGE_AGREEMENTS">
    </td-wb-modal-header-title>
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button></td-wb-modal-close-button>
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>
  <!-- Agreement Components Switch -->
  <div class="td-wb-form__agreements"
    >
    @switch (agreementType) {
      @case ('NYSE') {
        <td-wb-old-amex-nyse></td-wb-old-amex-nyse>
      }
      @case ('CEG') {
        <td-wb-old-ceg></td-wb-old-ceg>
      }
      @case ('NASDAQ') {
        <td-wb-old-nasdaq></td-wb-old-nasdaq>
      }
    }
  </div>
</div>
